module.exports = __webpack_public_path__ + "static/media/step2img9.14d8fba2.JPG";